function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.66634 0.666992H12.333C13.0694 0.666992 13.6663 1.26395 13.6663 2.00033V10.0003C13.6663 10.7367 13.0694 11.3337 12.333 11.3337H1.66634C0.929961 11.3337 0.333008 10.7367 0.333008 10.0003V2.00033C0.333008 1.26395 0.929961 0.666992 1.66634 0.666992ZM12.333 4.00033V2.00033H1.66634V4.00033H12.333ZM1.66634 10.0003V6.00033H12.333V10.0003H1.66634ZM3.33301 7.33366H5.33301C5.5171 7.33366 5.66634 7.4829 5.66634 7.66699V8.33366C5.66634 8.51775 5.5171 8.66699 5.33301 8.66699H3.33301C3.14891 8.66699 2.99967 8.51775 2.99967 8.33366V7.66699C2.99967 7.4829 3.14891 7.33366 3.33301 7.33366Z",
  fill: "#0E3132"
});

var SvgCreditcardIcon = function SvgCreditcardIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditcardIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CreditcardIcon.31b34661.svg";
export { ForwardRef as ReactComponent };